module.exports = __webpack_public_path__ + "media/madden-recap_highlight.f074150b.mp4";